import { RichText } from "components/RichTextWidget";
import {
  Action,
  Container,
  Heading2,
  Icon,
  Paragraph,
} from "shared/components";
import { useOffsetScroll } from "shared/hooks";

import styles from "./Hero032.module.scss";

export const Hero032 = ({ payload, position }) => {
  const headline = payload?.headline ?? "";
  const description = payload?.description ?? "";
  const buttonText = payload?.button?.buttonText ?? "";
  const widgetOffset = payload?.button?.widgetOffset ?? 0;

  const { scrollToTarget } = useOffsetScroll({ widgetOffset, position });

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.content}>
          <div className={styles.top}>
            <Heading2 className={styles.headline} color="dark">
              {headline}
            </Heading2>
            <Action onClick={scrollToTarget} className={styles.play}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph color="brand" appearance="bold">
                {buttonText}
              </Paragraph>
            </Action>
          </div>
          <RichText value={description} className={styles.description} />
        </div>
      </Container>
    </div>
  );
};

export default Hero032;
